.root {
  display: inline-flex;
  position: relative;
}

.icon {
  height: 16px;
  width: 16px;
}

.badgeAnchor {
  pointer-events: none;
  position: absolute;
  right: -4px;
  top: -4px;
}
